module.exports = __webpack_public_path__ + "static/media/vid4.27d3a93a.mp4";